const scrollbarCSS = {
  // "::-webkit-scrollbar": {
  //   display: "none",
  // },
};

export default scrollbarCSS;
